// extracted by mini-css-extract-plugin
module.exports = {"root":"y_M","nav":"y_bK","carousel":"y_bL","slide":"y_bM"};